import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="section-dark pt-16 pb-8 border-t border-[rgba(128,229,203,0.1)]">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo column */}
          <div className="md:col-span-1">
            <div className="mb-6 flex flex-col items-start">
              <img
                src="/Nura_Final-04.png"
                alt="Nura Health mobile pathology logo"
                style={{ height: '48px', width: 'auto', marginBottom: '8px', background: 'transparent', objectFit: 'contain' }}
              />
              <p className="text-[#9BA5C2] text-[13px] font-['Inter'] font-normal leading-relaxed mt-2">
                Mobile pathology, at your door.
              </p>
            </div>
            {/* Social icons */}
            <div className="flex items-center gap-6">
              <a
                href="https://www.instagram.com/n.u.r.a.health/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-white hover:text-[#80E5CB] transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.975 1.246 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.974-2.242 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948 0-3.259-.014-3.668-.072-4.948-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/nura-health-au/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-white hover:text-[#80E5CB] transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61590299686747"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-white hover:text-[#80E5CB] transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.514c-1.491 0-1.956.93-1.956 1.886v2.268h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Services column */}
          <div>
            <h4 className="text-white font-['Inter'] font-medium mb-4">Services</h4>
            <ul className="space-y-3">
              <li><a href="/services/home-blood-collection" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">At-Home Blood Collection</a></li>
              <li><a href="/services/aged-care-pathology" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">Aged Care Pathology</a></li>
              <li><a href="/services/ndis-pathology" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">NDIS Pathology</a></li>
              <li><a href="/services/corporate-pathology" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">Corporate & Workplace</a></li>
            </ul>
          </div>

          {/* Company column */}
          <div>
            <h4 className="text-white font-['Inter'] font-medium mb-4">Company</h4>
            <ul className="space-y-3">
              <li><a href="#why-nura" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">About Us</a></li>
              <li><a href="#how-it-works" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">How It Works</a></li>
              <li><a href="/pricing" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">View Pricing</a></li>
              <li><a href="/blog" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">Blog</a></li>
              <li><a href="#contact" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-sm">Contact</a></li>
            </ul>
          </div>

          {/* Contact column */}
          <div>
            <h4 className="text-white font-['Inter'] font-medium mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-[#9BA5C2] text-sm">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#80E5CB]" />
                <a href="tel:+61420424290" className="hover:text-[#80E5CB] transition-colors" onClick={() => { if (window.gtag) { window.gtag('event', 'click_phone', { event_category: 'engagement', event_label: 'Phone number clicked' }); } }}>+61 420 424 290</a>
              </li>
              <li className="flex items-start gap-2 text-[#9BA5C2] text-sm">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#80E5CB]" />
                <a href="mailto:hello@nurahealth.com.au" className="hover:text-[#80E5CB] transition-colors">hello@nurahealth.com.au</a>
              </li>
              <li className="flex items-start gap-2 text-[#9BA5C2] text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#80E5CB]" />
                <span>Brisbane, QLD<br />Australia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="divider my-8"></div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9BA5C2] text-xs text-center md:text-left">
            © {currentYear} Nura Health | ABN 80 126 969 531 | Brisbane, QLD, Australia
          </p>
          <div className="flex gap-6">
            <a href="/privacy" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-xs">Privacy Policy</a>
            <a href="/terms" className="text-[#9BA5C2] hover:text-[#80E5CB] transition-colors text-xs">Terms of Service</a>
          </div>
        </div>

        {/* Fine print */}
        <div className="mt-6">
          <p className="text-[#9BA5C2] text-xs leading-relaxed opacity-70 text-center">
            Nura Health is a specimen collection service. We do not provide medical advice or diagnose conditions.
            All testing is performed by accredited pathology laboratories.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;